import ExperienceTypesComponent from "../../../../components/partner/Settings/experience-types/experience-types";

export default function ExperienceTypes() {
  return <ExperienceTypesComponent />;
}
